import { useEffect, useState } from "react";

const KEY = "eneprox.theme";
const read = () => { try { return localStorage.getItem(KEY) === "dark" ? "dark" : "light"; } catch { return "light"; } };
export const applyTheme = (t) => document.documentElement.classList.toggle("theme-dark", t === "dark");
applyTheme(read());

export function useTheme() {
  const [theme, setTheme] = useState(read);
  useEffect(() => {
    applyTheme(theme);
    try { localStorage.setItem(KEY, theme); } catch { /* private mode */ }
    window.dispatchEvent(new Event("eneprox-theme"));
  }, [theme]);
  useEffect(() => {
    const on = () => setTheme(read());
    window.addEventListener("eneprox-theme", on);
    return () => window.removeEventListener("eneprox-theme", on);
  }, []);
  return [theme, () => setTheme((t) => (t === "dark" ? "light" : "dark"))];
}
